import React, { useEffect } from 'react';
import { CatalogForm } from '../../components/CatalogForm/index';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../utils/routes';
import { useDispatch, useSelector } from 'react-redux';
import {
  CheckCatalogVisitors,
  DeleteCatalogVisitors,
  GetCatalog,
  TypeUpdateCatalogR,
  UpdateCatalog,
} from '../../store/catalogues/actions';
import { GetBlocks } from '../../store/blocks/actions';
import { GetMainBlocks } from '../../store/main/actions';
import { AppStore } from '../../store/applicationState';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { ConfigurationsActions } from '../../store/configurations/actions';
import { IDocumentVisitor } from '../../store/consultations/types';
import { AlertModal } from '../../components/modals/AlertModal';

export const EditCatalog: React.FC = () => {
  const { Catalogues } = useSelector((store: AppStore) => store);
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [visitors, setVisitors] = React.useState<IDocumentVisitor[] | null>();

  useEffect(() => {
    if (id) {
      dispatch(GetCatalog.request({ id: Number(id) }));
      dispatch(
        CheckCatalogVisitors.request({
          id: +id,
        })
      );
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (Catalogues.current) {
      dispatch(ConfigurationsActions.setSiteId(Catalogues.current.site_id));
    }
  }, [dispatch, Catalogues]);

  React.useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      dispatch(DeleteCatalogVisitors.request({ id: !isNaN(Number(id)) ? Number(id) : 0 }));
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      dispatch(DeleteCatalogVisitors.request({ id: !isNaN(Number(id)) ? Number(id) : 0 }));
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [navigate, dispatch, id]);

  React.useEffect(() => {
    setVisitors(Catalogues.visitors);
  }, [Catalogues]);

  const handleUpdate = (
    data: TypeUpdateCatalogR['data'],
    callBack: (err?: { name: string; message: string }) => void
  ) => {
    if (!Catalogues.current) return null;
    dispatch(
      CheckCatalogVisitors.request({
        id: Catalogues.current.id,
      })
    );
    dispatch(
      UpdateCatalog.request({
        data,
        id: Catalogues.current.id,
        callBack: (success, dta) => {
          if (!success && dta) {
            if (dta.status === 409) {
              callBack({ name: 'title', message: 'Такий заголовок вже використовується' });
            } else if (dta.status === 410) {
              callBack({ name: 'error', message: 'Публікацію видалено' });
            } else {
              callBack({ name: 'error', message: 'Сталася помилка' });
            }
          } else {
            callBack();
          }
          if (success && Catalogues.current?.is_public === 1 && data.isPublic === 0) {
            dispatch(GetBlocks.request({ id: Catalogues.current.site_id }));
            dispatch(GetMainBlocks.request({ id: Catalogues.current.site_id }));
          }
        },
      })
    );
  };

  if (!Catalogues.current)
    return (
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100vh'}>
        <CircularProgress color='secondary' />
      </Box>
    );

  return (
    <>
      <AlertModal visitors={visitors} />
      <CatalogForm
        type='edit'
        data={Catalogues.current}
        handleSubmit={handleUpdate}
        handleCancel={() => {
          navigate(ROUTES.routeChange('list'));
          dispatch(DeleteCatalogVisitors.request({ id: !isNaN(Number(id)) ? Number(id) : 0 }));
        }}
      />
    </>
  );
};
